var map = {
	"./calendar.webp": 1527,
	"./cash.webp": 1528,
	"./check-in-title-bg.webp": 1529,
	"./coin.webp": 1530,
	"./current-check-in-container.webp": 1531,
	"./current-last-day-check-in-container.webp": 1532,
	"./daily-check-in-bg.webp": 1533,
	"./default-check-in-container.webp": 1534,
	"./giftbox.webp": 1535,
	"./golden-coin.webp": 1536,
	"./halfweek-check-in-container.webp": 1537,
	"./last-day-check-in-container.webp": 1538,
	"./missed-checkIn.webp": 1539,
	"./more-cash.webp": 1540,
	"./more-coin.webp": 1541,
	"./more-spin.webp": 1542,
	"./need-deposit.webp": 1543,
	"./present.webp": 1544,
	"./reward-coin.webp": 1545,
	"./shine.webp": 1546,
	"./silver-coin.webp": 1547,
	"./spin.webp": 1548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;